import { Form, Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { greenTick02, blackInfo } from '../../assets/images/images';
import { isFreeTierByProperties, isAdvancedTier, handleUpgrade as handleUpgradeUtil } from '../../utility/tierUtils';
import { ROUTES } from '../../resources/routes-constants';
import DisclaimerModal from './DisclaimerModal';

const PlanDetail = ({
    viewPlan,
    setViewPlan,
    assignedTier,
}: any) => {
    const navigate = useNavigate();
    const isFree = isFreeTierByProperties(assignedTier);
    const isAdvanced = isAdvancedTier(assignedTier);
    const [showDisclaimer, setShowDisclaimer] = useState(false);

    const handleUpgrade = () => {
        setViewPlan(false);
        handleUpgradeUtil(navigate, ROUTES.CONTACT_US_TO_UPGRADE_ROUTE);
    };
    
    const handleDisclaimerAccept = () => {
        setShowDisclaimer(false);
    };
    
    const handleDisclaimerClose = () => {
        setShowDisclaimer(false);
    };
    
    // Helper function to format limit values
    const formatLimit = (value: number) => {
        if (value >= 999999 || isAdvanced) {
            return 'Unlimited';
        }
        return value || 0;
    };

    return (
        <>
            <Modal show={viewPlan}
                    dialogClassName="modal-plan top-right-modal modal-dialog-centered "
                    className="confirmation-modal sign-up-modal"
            >
                <Modal.Body>
                    <div className="plan-modal-top-row">
                        <div className='current-plan-head'>CURRENT PLAN</div>
                        <Button
                            variant="cancel"
                            className="btn-cancel btn-cancel-filled close-top-btn"
                            onClick={() => setViewPlan(false)}
                        >
                            Close
                        </Button>
                    </div>
                    <div className="plan-name-with-info">
                        <h4 className="premium-plan-head">{assignedTier?.name}</h4>
                        {isFree && (
                            <img 
                                src={blackInfo} 
                                alt="Demo Information" 
                                className="demo-info-icon" 
                                onClick={() => setShowDisclaimer(true)}
                                title="Click for demo information"
                            />
                        )}
                    </div>
                    <ul className='premium-plan-list'>
                        <li><img src={greenTick02} alt="" className='plan-tick' />{isAdvanced ? 'Unlimited' : `Maximum of ${formatLimit(assignedTier?.no_of_downloads)}`} profile downloads.</li>
                        <li><img src={greenTick02} alt="" className='plan-tick' />{isAdvanced ? 'Unlimited' : `Maximum of ${formatLimit(assignedTier?.no_of_profile_views)}`} profile views.</li>
                        <li><img src={greenTick02} alt="" className='plan-tick' />{isAdvanced ? 'Unlimited' : `Maximum of ${formatLimit(assignedTier?.no_of_job_creation)}`} job creations.</li>
                    </ul>
                    <div className='premium-plan-tagline'>
                        <span>*</span>If you would like to change your plan, please contact the support team.
                    </div>
                    <div className='form-wrap'>
                        <Form className="full-width-form">
                            <div className="sign-btn-wrapper">
                                <Button 
                                    variant="primary" 
                                    className="upgrade-btn" 
                                    onClick={handleUpgrade}
                                    // Using CSS class for styling
                                >
                                    {isFree ? 'Contact us to upgrade' : 'CHANGE PLAN'}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
            
            {/* Disclaimer Modal for Demo Plans */}
            <DisclaimerModal
                show={showDisclaimer}
                onHide={handleDisclaimerClose}
                onAccept={handleDisclaimerAccept}
            />
        </>
    );
};

export default PlanDetail;
